import sdks, { EVENTS } from '@/utils/_sasdk'
import cookie from 'js-cookie'

// 注册公共属性
sdks.registerPage({
  object_version: 'v1.0.0',
  business: 'VIPKIDmath',
  object: 'MathGrowth',
  app_id: '703dc5d1afbb9d76',
  student_id: cookie.get('mbstudentid') || '',
  parent_id: cookie.get('mbparentid') || ''
})

const sasdk = Object.assign({
  viewindex () {
    this.track(EVENTS.page, {
      event_id: 'MathLandingPage_view',
      str1: '用户访问H5页面'
    })
  },
  videoplay () {
    this.track(EVENTS.click, {
      event_id: 'MathLandingPage_VideoPlay',
      str1: '视频点击播放'
    })
  },
  getfree () {
    this.track(EVENTS.click, {
      event_id: 'MathLandingPage_getFree_click',
      str1: '用户在H5页面内点击了领取button'
    })
  },
  clickbottom () {
    this.track(EVENTS.click, {
      event_id: 'MathLandingPage_bottom_click',
      str1: '吸底button点击'
    })
  },
  viewsuccess () {
    this.track(EVENTS.page, {
      event_id: 'MathLandingPage_SuccessfulPage_View',
      str1: '成功领取页'
    })
  },
  viewfail () {
    this.track(EVENTS.page, {
      event_id: 'MathLandingPage_FailedPage_View',
      str1: '重复领取页'
    })
  },
  leavepage (time, top) {
    this.track(EVENTS.page, {
      event_id: 'MathLandingPage_Close_Page',
      str1: '用户离开H5页面',
      str2: time + '',
      str3: top + ''
    })
  }
}, sdks)

export default sasdk
